<template>
  <va-text-input :label="$t('integrations.fields.tenant')" v-model="company" :readonly="true"></va-text-input>
</template>
<script>
export default {
  props: ["ofr"],
  computed: {
    company() {
      let companyStr = "";
      if (this.ofr !== undefined) {
        if (this.ofr.data !== undefined) {
          if (this.ofr.data[0] !== undefined) {
            if (this.ofr.data[0].order !== undefined) {
              companyStr = this.ofr.data[0].order.tenant;
            }
          }
        }
      }

      return companyStr;
    }
  }
};
</script>
